export const AUTH_CONFIG = {
  REACT_APP_LOGIN_URL: process.env.REACT_APP_LOGIN_URL || 'https://www4dev.kellogg.northwestern.edu/WebSSOExternalAuthSite/Login.aspx',
    AUTH_COOKIE_NAME: 'KSMToken',
    RETURN_URL_PARAM: 'returnUrl'
  } as const;

